import React, { useState, useEffect } from 'react'
import { SectionHeader } from '../Headlines'
import { useBreakpointContext } from '../../util/BreakpointProvider'
import './index.scss'

const preloadImages = (imagePaths) => {
  imagePaths.forEach(path => {
    const img = new Image()
    img.src = `assets/expeditionspage/goals/${path}`
  })
}


const CardSlider = ({ title, items, currentIndex, onIndexChange, isMobile = false }) => {
  const handleNext = () => {
    onIndexChange((prev) => (prev + 1) % items.length)
  }

  const handlePrev = () => {
    onIndexChange((prev) => (prev - 1 + items.length) % items.length)
  }

  return (
    <div className={isMobile ? 'fullColumn' : 'inset-half-column'}>
      {!isMobile && <div className="dashed-border bottom">
        <h3>{title}</h3>
      </div>
      }
      <div className="card-slider">
        <div className="card">
          <h3>{items[currentIndex].title}</h3>
          <img 
            src={`assets/expeditionspage/goals/${items[currentIndex].image}`} 
            alt="Illustration" 
            className="card-illustration"
          />
          <p>{items[currentIndex].text}</p>
        </div>
        <div className="navigation">
          <img 
            src="assets/icons/left_arrow.svg" 
            alt="previous" 
            onClick={handlePrev}
            className="nav-arrow"
          />
          <img 
            src="assets/icons/right_arrow.svg" 
            alt="next" 
            onClick={handleNext}
            className="nav-arrow"
          />
        </div>
      </div>
    </div>
  )
}

export function Goals({ content }) {
  const [habitatIndex, setHabitatIndex] = useState(0)
  const [behaviorIndex, setBehaviorIndex] = useState(0)
  const [mobileIndex, setMobileIndex] = useState(0)
  const { isMobile, isTablet } = useBreakpointContext()

  useEffect(() => {
    const allImagePaths = [
      ...content.goals.habitat.map(goal => goal.image),
      ...content.goals.behavior.map(goal => goal.image)
    ]
    preloadImages(allImagePaths)
  }, [content.goals])

  // Combine all items into a single array for mobile view
  const allItems = [...content.goals.habitat, ...content.goals.behavior]
  const habitatLength = content.goals.habitat.length

  // Determine which section we're in based on the current index
  const getCurrentSection = (index) => {
    return index < habitatLength ? 'Habitat' : 'Behavior'
  }

  if (isMobile || isTablet) {
    return (
      <section className='container inset goals no-border'>
        <SectionHeader title="Goals" topBorder />
        <div className="dashed-border bottom">
          <h3>{getCurrentSection(mobileIndex)}</h3>
        </div>
        <CardSlider 
          title={getCurrentSection(mobileIndex)}
          items={allItems}
          currentIndex={mobileIndex}
          onIndexChange={setMobileIndex}
          isMobile={true}
        />
      </section>
    )
  }

  return (
    <section className='container inset no-border goals'>
      <SectionHeader title="Goals" topBorder />

      <div className="flex">
        <CardSlider 
          title="Habitat"
          items={content.goals.habitat}
          currentIndex={habitatIndex}
          onIndexChange={setHabitatIndex}
        />

        <CardSlider 
          title="Behavior"
          items={content.goals.behavior}
          currentIndex={behaviorIndex}
          onIndexChange={setBehaviorIndex}
        />
      </div>
    </section>
  )
} 